export class RoomDefs {

        static room_list = [
            'P2-D', 'P2', 'P3', 'ANN', 'A2', 'A3', 'A4', 'A5-1', 
            'A6-A', 'A6', 'sharehouse', 'addperson', 'roomup', 'park', 'pet', 'p-p', 'taxi'];
}
        
    
